module.exports = __webpack_public_path__ + "img/icon_basic_avatar.2b6fd2f3.png";